import * as React from 'react';
import type { SVGProps } from 'react';
const SvgClockFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="url(#ClockFull_svg__a)"
      fillRule="evenodd"
      d="M7.2 14.4A7.2 7.2 0 1 0 7.2 0a7.2 7.2 0 0 0 0 14.4m.9-10.8a.9.9 0 0 0-1.8 0v3.375c0 .62.504 1.125 1.125 1.125H9.9a.9.9 0 1 0 0-1.8H8.1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClockFull;
